// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".md-overlay{z-index:13}", "",{"version":3,"sources":["webpack://src/components/modals/DeleteStoreModal.vue"],"names":[],"mappings":"AAAA,YAAY,UAAU","sourcesContent":[".md-overlay{z-index:13}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
